import PropTypes from 'prop-types'

import {MicIcon} from './icons'
import {LIFE_STORY_CHAPTERS} from './lifeStoryContent'

const PencilIcon = () => (
  <svg width='19' height='19' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
    <path d='M4 20l1-4L16.5 4.5a2.1 2.1 0 013 3L8 19l-4 1z' />
    <path d='M14 6.5l3 3' />
  </svg>
)

/** The invitation: A full-screen welcome with every chapter to begin from. */
const InvitationScreen = ({exit, startChapter}) => (
  <div>
    <div className='ls-top'>
      <button className='ls-exit' onClick={exit}>&larr; Back to my Everplan</button>
    </div>
    <div className='ls-invite'>
      <div className='ls-invite-kicker'>Your Story</div>
      <h1>Your life, in your own words</h1>
      <p className='ls-invite-sub'>
        Answer a few questions, your way &mdash; in writing or in your own voice. One story is
        a gift; twenty is a book. Start whenever you like, and we&rsquo;ll shape your answers
        into something beautiful to keep.
      </p>
      <div className='ls-methods'>
        <span className='ls-method'>
          <PencilIcon />
          <b>Write it</b>&nbsp;&mdash; a line or a page
        </span>
        <span className='ls-method'>
          <MicIcon />
          <b>Speak it</b>&nbsp;&mdash; we&rsquo;ll transcribe every word
        </span>
      </div>
      <div className='ls-invite-q'>Where would you like to begin?</div>
      <div className='ls-topic-grid'>
        {
          LIFE_STORY_CHAPTERS.map(chapter => (
            <button className='ls-topic-card' key={chapter.key} onClick={() => startChapter(chapter.key)}>
              <span className='ls-topic-name'>{chapter.name}</span>
              <span className='ls-topic-sub'>{chapter.description}</span>
            </button>
          ))
        }
      </div>
      <p className='ls-invite-foot'>Skip anything, stop anytime &mdash; everything saves as you go.</p>
    </div>
  </div>
)

InvitationScreen.propTypes = {
  exit: PropTypes.func,
  startChapter: PropTypes.func
}

export default InvitationScreen
